import { onBeforeUnmount, onMounted, ref } from "vue";

const MOBILE_BREAKPOINT = 768;

export function useBreakpoint() {
  const isMobile = ref(typeof window !== "undefined" ? window.innerWidth < MOBILE_BREAKPOINT : false);

  const update = () => {
    isMobile.value = window.innerWidth < MOBILE_BREAKPOINT;
  };

  onMounted(() => {
    update();
    window.addEventListener("resize", update);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("resize", update);
  });

  return { isMobile };
}
